// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"131":"ShopEdit","186":"ShopAdd"}[chunkId] + "." + {"131":"48a3f4c3","186":"48a3f4c3"}[chunkId] + ".css";
};